import React, { Fragment } from 'react'; 
import Header from "../common/header";
import Footer from "../common/footer";
import CollectionBanner from './collection-banner';
import CollectionAbout from './collection-about';
import CollectionProperties from './collection-properties';
import CollectionParallax from './collection-parallax';
import CollectionSoldProperties from './collection-sold-properties';

function CollectionPage () {
    return(
      <Fragment> 
      <Header />  
      <CollectionBanner />     
      <CollectionAbout /> 
      <CollectionProperties />
      <CollectionParallax />
      <CollectionSoldProperties />
      <Footer /> 
      </Fragment> 
    );
}
export default CollectionPage;